/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreationVisitePdaDto } from '../models/creation-visite-pda-dto';
import { GetOrCreateBelgeInfoByEIdRequestDto } from '../models/get-or-create-belge-info-by-e-id-request-dto';
import { PersonnePhysiquePdaDto } from '../models/personne-physique-pda-dto';
import { VisitePdaDto } from '../models/visite-pda-dto';
import { VisiteurPdaDto } from '../models/visiteur-pda-dto';


/**
 * Fonctions de gestion des visites et visiteurs (module PDA)
 */
@Injectable({
  providedIn: 'root',
})
export class VisitesPdaService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation visitePdaIdentificationBelgeByEId
   */
  static readonly VisitePdaIdentificationBelgeByEIdPath = '/api/visite-pda/identify-belge-eid';

  /**
   * Identifie un Belge sur base de sa carte d'identité.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaIdentificationBelgeByEId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitePdaIdentificationBelgeByEId$Response(params: {

    /**
     * Informations de la carte d'identité
     */
    body: GetOrCreateBelgeInfoByEIdRequestDto
  }): Observable<StrictHttpResponse<VisiteurPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaIdentificationBelgeByEIdPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteurPdaDto>;
      })
    );
  }

  /**
   * Identifie un Belge sur base de sa carte d'identité.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaIdentificationBelgeByEId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitePdaIdentificationBelgeByEId(params: {

    /**
     * Informations de la carte d'identité
     */
    body: GetOrCreateBelgeInfoByEIdRequestDto
  }): Observable<VisiteurPdaDto> {

    return this.visitePdaIdentificationBelgeByEId$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteurPdaDto>) => r.body as VisiteurPdaDto)
    );
  }

  /**
   * Path part for operation visitePdaIdentificationBelgeById
   */
  static readonly VisitePdaIdentificationBelgeByIdPath = '/api/visite-pda/identify-belge-id/{belgeId}';

  /**
   * Identifie un Belge sur base de son identifiant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaIdentificationBelgeById()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationBelgeById$Response(params: {

    /**
     * Identifiant du belge
     */
    belgeId: number;
  }): Observable<StrictHttpResponse<VisiteurPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaIdentificationBelgeByIdPath, 'get');
    if (params) {
      rb.path('belgeId', params.belgeId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteurPdaDto>;
      })
    );
  }

  /**
   * Identifie un Belge sur base de son identifiant.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaIdentificationBelgeById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationBelgeById(params: {

    /**
     * Identifiant du belge
     */
    belgeId: number;
  }): Observable<VisiteurPdaDto> {

    return this.visitePdaIdentificationBelgeById$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteurPdaDto>) => r.body as VisiteurPdaDto)
    );
  }

  /**
   * Path part for operation visitePdaIdentificationBelgeByNationalNumber
   */
  static readonly VisitePdaIdentificationBelgeByNationalNumberPath = '/api/visite-pda/identity-belge-national-number/{nationalNumber}';

  /**
   * Identifie un Belge au moyen du code barres présent sur sa carte d'identité.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaIdentificationBelgeByNationalNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationBelgeByNationalNumber$Response(params: {

    /**
     * Code barres
     */
    codeBarres?: string;
    nationalNumber: string;
  }): Observable<StrictHttpResponse<VisiteurPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaIdentificationBelgeByNationalNumberPath, 'get');
    if (params) {
      rb.query('codeBarres', params.codeBarres, {});
      rb.path('nationalNumber', params.nationalNumber, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteurPdaDto>;
      })
    );
  }

  /**
   * Identifie un Belge au moyen du code barres présent sur sa carte d'identité.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaIdentificationBelgeByNationalNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationBelgeByNationalNumber(params: {

    /**
     * Code barres
     */
    codeBarres?: string;
    nationalNumber: string;
  }): Observable<VisiteurPdaDto> {

    return this.visitePdaIdentificationBelgeByNationalNumber$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteurPdaDto>) => r.body as VisiteurPdaDto)
    );
  }

  /**
   * Path part for operation visitePdaIdentificationPmById
   */
  static readonly VisitePdaIdentificationPmByIdPath = '/api/visite-pda/identify-pm-id/{pmId}';

  /**
   * Identifie une personne morale sur base de son identifiant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaIdentificationPmById()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationPmById$Response(params: {

    /**
     * Identifiant de la personne morale
     */
    pmId: number;
  }): Observable<StrictHttpResponse<VisiteurPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaIdentificationPmByIdPath, 'get');
    if (params) {
      rb.path('pmId', params.pmId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteurPdaDto>;
      })
    );
  }

  /**
   * Identifie une personne morale sur base de son identifiant.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaIdentificationPmById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationPmById(params: {

    /**
     * Identifiant de la personne morale
     */
    pmId: number;
  }): Observable<VisiteurPdaDto> {

    return this.visitePdaIdentificationPmById$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteurPdaDto>) => r.body as VisiteurPdaDto)
    );
  }

  /**
   * Path part for operation visitePdaIdentificationPpById
   */
  static readonly VisitePdaIdentificationPpByIdPath = '/api/visite-pda/identify-pp-id/{ppId}';

  /**
   * Identifie une personne physique sur base de son identifiant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaIdentificationPpById()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationPpById$Response(params: {

    /**
     * Identifiant de la personne physique
     */
    ppId: number;
  }): Observable<StrictHttpResponse<VisiteurPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaIdentificationPpByIdPath, 'get');
    if (params) {
      rb.path('ppId', params.ppId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteurPdaDto>;
      })
    );
  }

  /**
   * Identifie une personne physique sur base de son identifiant.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaIdentificationPpById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationPpById(params: {

    /**
     * Identifiant de la personne physique
     */
    ppId: number;
  }): Observable<VisiteurPdaDto> {

    return this.visitePdaIdentificationPpById$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteurPdaDto>) => r.body as VisiteurPdaDto)
    );
  }

  /**
   * Path part for operation visitePdaIdentificationByQrCode
   */
  static readonly VisitePdaIdentificationByQrCodePath = '/api/visite-pda/identify-qrcode/{qrCode}';

  /**
   * Identifie un visiteur à partir d'un QR code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaIdentificationByQrCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationByQrCode$Response(params: {

    /**
     * QR code
     */
    qrCode: string;
  }): Observable<StrictHttpResponse<VisiteurPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaIdentificationByQrCodePath, 'get');
    if (params) {
      rb.path('qrCode', params.qrCode, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteurPdaDto>;
      })
    );
  }

  /**
   * Identifie un visiteur à partir d'un QR code.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaIdentificationByQrCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationByQrCode(params: {

    /**
     * QR code
     */
    qrCode: string;
  }): Observable<VisiteurPdaDto> {

    return this.visitePdaIdentificationByQrCode$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteurPdaDto>) => r.body as VisiteurPdaDto)
    );
  }

  /**
   * Path part for operation visitePdaIdentificationByBarcode
   */
  static readonly VisitePdaIdentificationByBarcodePath = '/api/visite-pda/identity-barcode/{barcode}';

  /**
   * Identifie un visiteur à partir d'un code-barres.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaIdentificationByBarcode()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationByBarcode$Response(params: {

    /**
     * Code-barres
     */
    barcode: string;
  }): Observable<StrictHttpResponse<VisiteurPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaIdentificationByBarcodePath, 'get');
    if (params) {
      rb.path('barcode', params.barcode, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteurPdaDto>;
      })
    );
  }

  /**
   * Identifie un visiteur à partir d'un code-barres.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaIdentificationByBarcode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationByBarcode(params: {

    /**
     * Code-barres
     */
    barcode: string;
  }): Observable<VisiteurPdaDto> {

    return this.visitePdaIdentificationByBarcode$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteurPdaDto>) => r.body as VisiteurPdaDto)
    );
  }

  /**
   * Path part for operation visitePdaIdentificationByCode
   */
  static readonly VisitePdaIdentificationByCodePath = '/api/visite-pda/identity-code/{code}';

  /**
   * Identifie un visiteur à partir d'un code-barres ou d'un QR code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaIdentificationByCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationByCode$Response(params: {

    /**
     * Code-barres ou QR code
     */
    code: string;
  }): Observable<StrictHttpResponse<VisiteurPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaIdentificationByCodePath, 'get');
    if (params) {
      rb.path('code', params.code, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisiteurPdaDto>;
      })
    );
  }

  /**
   * Identifie un visiteur à partir d'un code-barres ou d'un QR code.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaIdentificationByCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaIdentificationByCode(params: {

    /**
     * Code-barres ou QR code
     */
    code: string;
  }): Observable<VisiteurPdaDto> {

    return this.visitePdaIdentificationByCode$Response(params).pipe(
      map((r: StrictHttpResponse<VisiteurPdaDto>) => r.body as VisiteurPdaDto)
    );
  }

  /**
   * Path part for operation visitePdaCreateVisite
   */
  static readonly VisitePdaCreateVisitePath = '/api/visite-pda/visite';

  /**
   * Crée une visite pour la personne spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaCreateVisite()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitePdaCreateVisite$Response(params: {

    /**
     * Informations de la visite
     */
    body: CreationVisitePdaDto
  }): Observable<StrictHttpResponse<VisitePdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaCreateVisitePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisitePdaDto>;
      })
    );
  }

  /**
   * Crée une visite pour la personne spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaCreateVisite$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitePdaCreateVisite(params: {

    /**
     * Informations de la visite
     */
    body: CreationVisitePdaDto
  }): Observable<VisitePdaDto> {

    return this.visitePdaCreateVisite$Response(params).pipe(
      map((r: StrictHttpResponse<VisitePdaDto>) => r.body as VisitePdaDto)
    );
  }

  /**
   * Path part for operation visitePdaSearchByNameAndBirthday
   */
  static readonly VisitePdaSearchByNameAndBirthdayPath = '/api/visite-pda/search-belge';

  /**
   * Recherche des Belges par leur nom (case-insensitive) et leur année de de naissance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaSearchByNameAndBirthday()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaSearchByNameAndBirthday$Response(params?: {

    /**
     * Nom recherché (ou une partie du nom)
     */
    name?: string;

    /**
     * Année de naissance recherchée
     */
    birthdayYear?: string;
  }): Observable<StrictHttpResponse<Array<PersonnePhysiquePdaDto>>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaSearchByNameAndBirthdayPath, 'get');
    if (params) {
      rb.query('name', params.name, {});
      rb.query('birthdayYear', params.birthdayYear, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PersonnePhysiquePdaDto>>;
      })
    );
  }

  /**
   * Recherche des Belges par leur nom (case-insensitive) et leur année de de naissance.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaSearchByNameAndBirthday$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaSearchByNameAndBirthday(params?: {

    /**
     * Nom recherché (ou une partie du nom)
     */
    name?: string;

    /**
     * Année de naissance recherchée
     */
    birthdayYear?: string;
  }): Observable<Array<PersonnePhysiquePdaDto>> {

    return this.visitePdaSearchByNameAndBirthday$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PersonnePhysiquePdaDto>>) => r.body as Array<PersonnePhysiquePdaDto>)
    );
  }

  /**
   * Path part for operation visitePdaSearchByPlaque
   */
  static readonly VisitePdaSearchByPlaquePath = '/api/visite-pda/search-etranger-plaque/{plaque}';

  /**
   * Recherche des étrangers par leur plaque (case-insensitive).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaSearchByPlaque()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaSearchByPlaque$Response(params: {

    /**
     * Plaque recherchée (ou une partie de la plaque)
     */
    plaque: string;
  }): Observable<StrictHttpResponse<Array<PersonnePhysiquePdaDto>>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaSearchByPlaquePath, 'get');
    if (params) {
      rb.path('plaque', params.plaque, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PersonnePhysiquePdaDto>>;
      })
    );
  }

  /**
   * Recherche des étrangers par leur plaque (case-insensitive).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaSearchByPlaque$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaSearchByPlaque(params: {

    /**
     * Plaque recherchée (ou une partie de la plaque)
     */
    plaque: string;
  }): Observable<Array<PersonnePhysiquePdaDto>> {

    return this.visitePdaSearchByPlaque$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PersonnePhysiquePdaDto>>) => r.body as Array<PersonnePhysiquePdaDto>)
    );
  }

  /**
   * Path part for operation visitePdaGetPendingVisite
   */
  static readonly VisitePdaGetPendingVisitePath = '/api/visite-pda/visite/{visiteId}';

  /**
   * Récupère une visite info.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitePdaGetPendingVisite()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaGetPendingVisite$Response(params: {

    /**
     * Identifiant de la visite à récupérer
     */
    visiteId: number;
  }): Observable<StrictHttpResponse<VisitePdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, VisitesPdaService.VisitePdaGetPendingVisitePath, 'get');
    if (params) {
      rb.path('visiteId', params.visiteId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VisitePdaDto>;
      })
    );
  }

  /**
   * Récupère une visite info.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `visitePdaGetPendingVisite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitePdaGetPendingVisite(params: {

    /**
     * Identifiant de la visite à récupérer
     */
    visiteId: number;
  }): Observable<VisitePdaDto> {

    return this.visitePdaGetPendingVisite$Response(params).pipe(
      map((r: StrictHttpResponse<VisitePdaDto>) => r.body as VisitePdaDto)
    );
  }

}
